import React from 'react';
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../../Context/LanguageContext';

const RegisterForm = (props) => {
  const { handleSubmit, handleChange, countries, values, errors } = props;
  const { t } = useTranslation();

  return (
    <>
      <Form role='form' onSubmit={handleSubmit}>
        <div className='row'>
          <div className='col-md-6 mb-3'>
            <input
              className='form-control'
              type='text'
              name='name'
              value={values.name}
              onChange={handleChange}
              placeholder={t('fullName')}
            />
            {errors.name && (
              <small className='text-danger ps-2'>{errors.name}</small>
            )}
          </div>
          <div className='col-md-6 mb-3'>
            <input
              className='form-control'
              type='text'
              name='username'
              value={values.username}
              onChange={handleChange}
              placeholder={t('username')}
            />
            {errors.username && (
              <small className='text-danger ps-2'>{errors.username}</small>
            )}
          </div>
        </div>

        <div className='row'>
          <div className='col-md-6 mb-3'>
            <input
              className='form-control'
              type='email'
              name='email'
              value={values.email}
              onChange={handleChange}
              placeholder={t('email')}
            />
            {errors.email && (
              <small className='text-danger ps-2'>{errors.email}</small>
            )}
          </div>
          <div className='col-md-6 mb-3'>
            <input
              className='form-control'
              type='text'
              name='mobile_no'
              value={values.mobile_no}
              onChange={handleChange}
              placeholder={t('mobileNumber')}
            />
            {errors.mobile_no && (
              <small className='text-danger ps-2'>{errors.mobile_no}</small>
            )}
          </div>
        </div>

        <div className='row'>
          <div className='col-md-6 mb-3'>
            <input
              className='form-control'
              type='password'
              name='password'
              value={values.password}
              onChange={handleChange}
              placeholder={t('password')}
            />
            {errors.password && (
              <small className='text-danger ps-2'>{errors.password}</small>
            )}
          </div>
          <div className='col-md-6 mb-3'>
            <input
              className='form-control'
              type='password'
              name='confirm_password'
              value={values.confirm_password}
              onChange={handleChange}
              placeholder={t('confirmPassword')}
            />
            {errors.confirm_password && (
              <small className='text-danger ps-2'>
                {errors.confirm_password}
              </small>
            )}
          </div>
        </div>
        <Form.Group className='mb-3'>
          <select
            className='form-control'
            aria-label='Default select example'
            name='country_id'
            value={values.country_id}
            onChange={handleChange}
          >
            <option value=''>{t('selectCountry')}</option>
            {countries &&
              countries.length &&
              countries.map((country) => (
                <option value={country.id} key={country.id}>
                  {country.country_name}
                </option>
              ))}
          </select>
          {errors.country_id && (
            <small className='text-danger ps-2'>{errors.country_id}</small>
          )}
        </Form.Group>

        <div className='d-flex mb-3 justify-content-center gap-3'>
          <div className='form-check'>
            <input
              className='form-check-input'
              type='radio'
              value='Buyer'
              name='role'
              id='regRoleBuyer'
              onChange={handleChange}
              checked={values.role === 'Buyer'}
            />
            <label
              className='form-check-label text-muted'
              htmlFor='regRoleBuyer'
            >
              {t('buyer')}
            </label>
          </div>
          <div className='form-check'>
            <input
              className='form-check-input'
              type='radio'
              value='Supplier'
              name='role'
              id='regRoleSupplier'
              onChange={handleChange}
              checked={values.role === 'Supplier'}
            />
            <label
              className='form-check-label text-muted'
              htmlFor='regRoleSupplier'
            >
              {t('supplier')}
            </label>
          </div>
        </div>
        <p className='text-center'>
          {errors.role && <small className='text-danger'>{errors.role}</small>}
        </p>

        <div className='form-check text-start mb-3'>
          <input
            className='form-check-input'
            type='checkbox'
            value=''
            id='flexCheckDefault'
          />
          <label
            className='form-check-label text-muted'
            htmlFor='flexCheckDefault'
          >
            {t('agreeTerms')}{' '}
            <button
              type='button'
              className='btn btn-link p-0 text-gold font-weight-bolder text-decoration-none'
              style={{ verticalAlign: 'baseline', boxShadow: 'none' }}
            >
              {t('termsAndConditions')}
            </button>
          </label>
        </div>
        <div className='text-center'>
          <button type='submit' className='btn btn-primary w-100 mb-0'>
            {t('signUp')}
          </button>
        </div>
      </Form>
      <div className='card-footer text-center pt-0 px-lg-2 px-1 mt-4 border-0 bg-transparent'>
        <p className='mb-2 text-sm mx-auto text-muted'>
          {t('alreadyHaveAccount')}
          <Link to='/' className='text-gold font-weight-bold ms-1'>
            {t('signIn')}
          </Link>
        </p>
      </div>
    </>
  );
};

export default RegisterForm;
